import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import { CONFIG, CONFIG_UTIL } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import utilManagement from '../../../../../apis/utilManagement';
import Loader from '../../../../Loader';
import __ from 'lodash';
import {Row, Col, Alert, Modal} from 'react-bootstrap';

import { makeStyles } from '@material-ui/core/styles';
import {List, ListItem, ListItemText, ListItemIcon} from '@material-ui/core';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import PersonIcon from '@material-ui/icons/Person';
import Tooltip from '@material-ui/core/Tooltip';


class RenderSiswaReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            listMapel: [],
            siswa: {}
        }
    }

    cariPengerjaan = async (siswa) =>{
        this.setState({open: true, isSearch: true, listMapel: [], siswa: siswa })
        const response = await accountManagement.post(CONFIG.FETCH_DETAIL_CBT_SISWA_BY_ID_JADWAL, {
            'idHeaderHasilCbt' : siswa.idHeaderHasilCbt,
            'idJadwalCbt': this.props.idJadwal,
            'tipe': this.props.kodeTipe,
        }).catch(function(error){});

        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listMapel: response.data.data.mapelCbt
                })
            }
            this.setState({ isSearch: false })
        }
    }

    componentDidMount(){
        console.clear();
        console.info('LOG PROPS ::> ',this.props.listSiswa)
    }

    modalDetailPengerjaan(){
          const {open, siswa, listMapel} = this.state;

          return (
              <Modal
                    show={open}
                    onHide={() => this.setState({ open: false })}
                    aria-labelledby="example-custom-modal-styling-title"
                    size="lg" backdrop="static" keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Pengerjaan "{siswa.namaSiswa}"</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{marginLeft: '10px'}}>
                        <Row>
                            {!__.isEmpty(listMapel) &&
                                <table width="100%">
                                    <thead>
                                        <tr>
                                            <th width="15%">No</th>
                                            <th>Nama Test</th>
                                            <th>Reset Status</th>
                                            <th>Reset Timer</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            listMapel.map((val, i)=>
                                            <tr key={i}>
                                                <td>{i+1}</td>
                                                <td>{val.namaMataPelajaran}</td>
                                                <td>
                                                    {
                                                        val.statusPengerjaan > 0 ?
                                                        <button className="btn btn-outline-success" title="Reset Status Pengerjaan" onClick={(e) => this.eksekusiReset(val.idSubHeaderHasilCbt, 0)}>
                                                            <li className="fa fa-check-square"></li>
                                                        </button>
                                                        :
                                                        <button className="btn btn-outline-danger" title="Belum Mengumpulkan"> 
                                                            <li className="fa fa-window-close"></li>
                                                        </button>
                                                    }
                                                </td>
                                                <td>
                                                    <button className="btn btn-outline-primary" onClick={(e) => this.eksekusiResetTimer(val.idProfil, val.idSubProfil, siswa.idSiswa)}> 
                                                        <li className="fa fa-clock-o"> Timer</li>
                                                    </button>  
                                                </td>
                                            </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            }
                        </Row>
                    </Modal.Body>
                </Modal>
          );
    }

    eksekusiReset = async (id, idSiswa)=>{
        this.setState({isSearch: true});

        const eksReset = await accountManagement.get(CONFIG.RESET_STATUS_PENGERJAAN+id+'&idSiswa='+idSiswa)
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        if(eksReset.request.readyState === 4 && eksReset.status === 200) {
            if(eksReset.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.cariPengerjaan(this.state.siswa)
                this.props.refreshListSiswa();
            }
        }
        this.setState({isSearch: false});
    }

    eksekusiResetTimer = async (idProfil, idSubProfil, idSiswa)=>{
        this.setState({isSearch: true});

        const eksReset = await utilManagement.delete(CONFIG_UTIL.UTIL_RESET_TIMER_SISWA+idProfil+'/'+idSubProfil+'/'+idSiswa+'/123')
        .catch(function(error) {
            console.log('kelas error '+error)
        });
        this.setState({isSearch: false});
    }


    render() { 
        const useStyles = makeStyles((theme) => ({
            root: {
              width: '100%',
              maxWidth: 360,
              backgroundColor: theme.palette.background.paper,
            },
            nested: {
              paddingLeft: theme.spacing(4),
            },
          }));

        return (
            <div>
                <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    className={useStyles.root}
                    >
                    {this.props.listSiswa.map((siswa, i)=>
                        <ListItem key={siswa.idSiswa} button onClick={(e) => this.cariPengerjaan(siswa)}>
                            <ListItemIcon><PersonIcon /></ListItemIcon>
                            <ListItemText primary={siswa.namaSiswa} />
                            {siswa.idHeaderHasilCbt != "0" ? 
                                <Tooltip title="Sudah Mengerjankan"><CheckCircleOutlineOutlinedIcon  color="primary" /></Tooltip>
                                 : <Tooltip title="Belum Mengerjakan sama sekali"><CancelOutlinedIcon color="secondary"/></Tooltip>}
                        </ListItem>
                    )}
                </List>
                {this.modalDetailPengerjaan()}
            </div>
        );
    }

    loading = () =>{
        if(this.state.isSearch) {
            return(
                <Loader />
            )
        }
    }
}
 
export default RenderSiswaReset;